module.exports = __webpack_public_path__ + "img/T1C_rc_21.710b1c20.png";